import { startOfDay } from "date-fns";
import formatValidDate from "../utils/format-valid-date";
import { GeneralFieldController } from "./general-field-controller";

export class AssessmentDateFieldController extends GeneralFieldController {
	override mapInitialValue(value: unknown): unknown {
		return this.parent.context.flexEntity ? value : formatValidDate(startOfDay(new Date()));
	}
}
